












































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { Form } from 'element-ui'
import { cloneDeep } from 'lodash'
import { getEmployees, createEmployee, updateEmployee, defaultEmployeeData, defaultCommentData, commentEmployee, deleteEmployee, findEmployeeComments } from '@/api/employees'
import { IComment, IEmployee } from '@/api/types'
import { exportJson2Excel } from '@/utils/excel'
import { formatJson } from '@/utils'
import Pagination from '@/components/Pagination/index.vue'

@Component({
  name: 'EmployeeTable',
  components: {
    Pagination
  }
})
export default class extends Vue {
  private tableKey = 0
  private list: IEmployee[] = []
  private comments : IComment[] = []
  private total = 0
  private listLoading = true
  private listQuery = {
    page: 1,
    limit: 10,
    name: undefined
  }

  private dialogFormVisible = false
  private dialogCommentVisible = false
  private dialogStatus = ''
  private textMap = {
    update: 'Edit',
    create: 'Create'
  }

  private rules = {
    name: [{ required: true, message: 'name is required', trigger: 'blur' }]
  }

  private downloadLoading = false
  private tempEmployeeData = defaultEmployeeData
  private tempCommentData = defaultCommentData

  created() {
    this.getList()
  }

  private async changePage(data : any) {
    this.listQuery.page = data.page
    this.getList()
  }

  private async getList() {
    this.listLoading = true
    const { data } = await getEmployees(this.listQuery)
    this.list = data.records
    this.total = data.total
    setTimeout(() => {
      this.listLoading = false
    }, 0.5 * 1000)
  }

  private handleFilter() {
    this.listQuery.page = 1
    this.getList()
  }

  private resetTempEmployeeData() {
    this.tempEmployeeData = cloneDeep(defaultEmployeeData)
  }

  private resetTempCommentData() {
    this.tempCommentData = cloneDeep(defaultCommentData)
  }

  private commentEmployee() {
    (this.$refs.dataForm as Form).validate(async(valid) => {
      if (valid) {
        const commentData = this.tempCommentData
        // FIXME: get current user after real user system ready!
        commentData.commentBy = 'houko'
        const { data } = await commentEmployee(this.tempEmployeeData.id, commentData)
        this.getList()
        if (data) {
          this.dialogCommentVisible = false
          this.$notify({
            title: 'success',
            message: 'create succss',
            type: 'success',
            duration: 2000
          })
        }
      }
    })
  }

  private handleCreate() {
    this.resetTempEmployeeData()
    this.comments = []
    this.dialogStatus = 'create'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate()
    })
  }

  private createData() {
    (this.$refs.dataForm as Form).validate(async(valid) => {
      if (valid) {
        const employeeData = this.tempEmployeeData
        const { data } = await createEmployee(employeeData)
        if (data) {
          this.getList()
          this.dialogFormVisible = false
          this.$notify({
            title: 'success',
            message: 'create employee succss',
            type: 'success',
            duration: 2000
          })
        }
      }
    })
  }

  private handleComment(row: IEmployee) {
    this.tempEmployeeData = Object.assign({}, row)
    this.tempCommentData = Object.assign({}, defaultCommentData)
    console.log(this.tempCommentData)
    this.dialogCommentVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate()
    })
  }

  /**
   * update
   */
  private async handleUpdate(row: IEmployee) {
    const { data } = await findEmployeeComments(row.id)
    if (data) {
      this.comments = data
    }
    this.tempEmployeeData = Object.assign({}, row)
    this.dialogStatus = 'update'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate()
    })
  }

  private updateData() {
    (this.$refs.dataForm as Form).validate(async(valid) => {
      if (valid) {
        const tempData = Object.assign({}, this.tempEmployeeData)
        const { data } = await updateEmployee(tempData.id, tempData)
        if (data) {
          this.dialogFormVisible = false
          this.getList()
          this.$notify({
            title: 'success',
            message: 'update success',
            type: 'success',
            duration: 2000
          })
        }
      }
    })
  }

  private async confirmDelete(row: IEmployee) {
    this.$confirm('this operation will delte the data, continue?', 'tips', {
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      type: 'warning'
    }).then(() => {
      this.handleDelete(row)
    }).catch(() => {
      this.$message({
        type: 'info',
        message: 'Canceld!'
      })
    })
  }

  private async handleDelete(row: IEmployee) {
    const { data } = await deleteEmployee(row.id)
    if (data) {
      this.$notify({
        title: 'Success',
        message: 'Delete Successfully',
        type: 'success',
        duration: 2000
      })
      this.getList()
    }
  }

  private handleDownloadComments() {
    if (!this.comments || this.comments.length === 0) {
      this.$message.error('no data to export,please check')
      return
    }
    this.downloadLoading = true
    const tHeader = ['id', 'content', 'star']
    const filterVal = ['id', 'content', 'star']
    const data = formatJson(filterVal, this.comments)
    exportJson2Excel(tHeader, data, 'employeeComments')
    this.downloadLoading = false
  }

  private handleDownload() {
    this.downloadLoading = true
    const tHeader = ['id', 'name', 'commentCount']
    const filterVal = ['id', 'name', 'commentCount']
    const data = formatJson(filterVal, this.list)
    exportJson2Excel(tHeader, data, 'employeeData')
    this.downloadLoading = false
  }
}
